export const features = [
  {
    id: 1,
    icon: 'ri-drag-drop-line',
    title: '拖拽式编辑器',
    description: '无需任何编程知识，通过直观的拖拽操作即可自由设计网页布局，像搭积木一样简单有趣。',
  },
  {
    id: 2,
    icon: 'ri-smartphone-line',
    title: '响应式设计',
    description: '所有模板均自动适配电脑、平板和手机屏幕，确保您的网站在任何设备上都完美呈现。',
  },
  {
    id: 3,
    icon: 'ri-palette-line',
    title: '海量精美模板',
    description: '提供超过2000套专业设计师打造的网站模板，涵盖企业、电商、博客、作品集等各类场景。',
  },
  {
    id: 4,
    icon: 'ri-search-line',
    title: 'SEO智能优化',
    description: '内置搜索引擎优化工具，自动生成站点地图和结构化数据，助您的网站获得更好的搜索排名。',
  },
  {
    id: 5,
    icon: 'ri-global-line',
    title: '自定义域名',
    description: '支持绑定您的专属域名，打造独一无二的品牌形象，让您的网站更专业、更值得信赖。',
  },
  {
    id: 6,
    icon: 'ri-shield-check-line',
    title: '安全稳定托管',
    description: '采用全球CDN加速和SSL加密技术，确保网站访问速度快如闪电，数据传输安全可靠。',
  },
];

export const stats = [
  { value: '500万+', label: '全球用户' },
  { value: '2000+', label: '精美模板' },
  { value: '99.9%', label: '在线率保障' },
  { value: '24/7', label: '技术支持' },
];